import { render, staticRenderFns } from "./DC_env_all.vue?vue&type=template&id=4e5d275d&scoped=true"
import script from "./DC_env_all.vue?vue&type=script&lang=js"
export * from "./DC_env_all.vue?vue&type=script&lang=js"
import style0 from "./DC_env_all.vue?vue&type=style&index=0&id=4e5d275d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5d275d",
  null
  
)

export default component.exports